/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minAnswers: NonNullable<unknown> }} Bold_Sage_Fox_GazeInputs */

const en_bold_sage_fox_gaze = /** @type {(inputs: Bold_Sage_Fox_GazeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Round-specific min answers: ${i?.minAnswers}`)
};

const de_bold_sage_fox_gaze = /** @type {(inputs: Bold_Sage_Fox_GazeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rundenspezifische Mindestantworten: ${i?.minAnswers}`)
};

/**
* | output |
* | --- |
* | "Round-specific min answers: {minAnswers}" |
*
* @param {Bold_Sage_Fox_GazeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_sage_fox_gaze = /** @type {((inputs: Bold_Sage_Fox_GazeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Sage_Fox_GazeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_sage_fox_gaze(inputs)
	return de_bold_sage_fox_gaze(inputs)
});